module.exports = __webpack_public_path__ + "img/panelView_defaultBg_2_2.b1685574.png";